import { Icon } from '@iconify/react';
import React from 'react';

const SOCIAL_LINKS = [
  { label: 'Instagram', icon: 'fa-brands:instagram', href: 'https://www.instagram.com/noohraservices?igsh=MTh5dW9neHZpeDMwNA==' },
  { label: 'TikTok', icon: 'fa-brands:tiktok', href: 'https://www.tiktok.com/@noohraservices?_t=ZM-8tdIb55Z3PJ&_r=1' },
  { label: 'YouTube', icon: 'fa-brands:youtube', href: 'https://youtube.com/@noohralife?si=EradZ0feG2UPqDCj' },
  { label: 'LinkedIn', icon: 'fa-brands:linkedin-in', href: 'https://www.linkedin.com/company/noohra-services/' },
  { label: 'X (Twitter)', icon: 'fa-brands:twitter', href: 'https://x.com/NoohraNigeria?t=DFjWSwph_duuA4JP879dZA&s=09' },
];

export default function SocialWidget({ title }) {
  return (
    <div className="flex flex-col items-center md:items-start gap-3">
      {title && <h2 className="font-serif text-2xl font-light text-charcoal m-0">{title}</h2>}
      <div className="flex items-center gap-1">
        {SOCIAL_LINKS.map(({ label, icon, href }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            className="w-11 h-11 flex items-center justify-center rounded-full text-current opacity-90 transition hover:opacity-100 hover:bg-white/10"
          >
            <Icon width={22} icon={icon} />
          </a>
        ))}
      </div>
    </div>
  );
}
